import type { Cycle, CycleTemplate } from "./api.ts";

/**
 * A session's colour, by its place in the cycle: `.hue-1` to `.hue-4` in
 * styles.css. A fifth session starts the round again.
 */
export const HUES = 4;

export function hueIndex(position: number): number {
  return ((Math.max(position, 1) - 1) % HUES) + 1;
}

/** The class that gives a card its session's colours. */
export const hueClass = (position: number) => `hue-${hueIndex(position)}`;

/**
 * The session to do next: among those still to do this week, the one done
 * longest ago — never done comes first. Null once the week is complete.
 */
export function nextTemplate(cycle: Cycle | null): CycleTemplate | null {
  const remaining = (cycle?.templates ?? []).filter((template) => !template.doneThisWeek);
  if (remaining.length === 0) return null;
  return remaining.reduce((oldest, template) =>
    (template.lastPerformedOn ?? "") < (oldest.lastPerformedOn ?? "") ? template : oldest,
  );
}
